class Testimonials {
    _isDragging = false;
    _startX = 0;
    _scrollLeft = 0;

    /* Private methods
    ******************** */
    _initDragScroll = () => {
        const scrollContainer = document.querySelector('.testimonials-scroll-container');

        if (!scrollContainer) {
            return;
        }

        // Changer le curseur
        scrollContainer.style.cursor = 'grab';

        scrollContainer.addEventListener('mousedown', (event) => {
            this._isDragging = true;
            scrollContainer.style.cursor = 'grabbing';
            scrollContainer.style.userSelect = 'none';

            this._startX = event.pageX - scrollContainer.offsetLeft;
            this._scrollLeft = scrollContainer.scrollLeft;
        });

        scrollContainer.addEventListener('mouseleave', () => {
            if (this._isDragging) {
                this._isDragging = false;
                scrollContainer.style.cursor = 'grab';
                scrollContainer.style.userSelect = '';
            }
        });

        scrollContainer.addEventListener('mouseup', () => {
            this._isDragging = false;
            scrollContainer.style.cursor = 'grab';
            scrollContainer.style.userSelect = '';
        });

        scrollContainer.addEventListener('mousemove', (event) => {
            if (!this._isDragging) {
                return;
            }

            event.preventDefault();

            const x = event.pageX - scrollContainer.offsetLeft;
            const walk = (x - this._startX) * 2; // Multiplier pour un scroll plus rapide
            scrollContainer.scrollLeft = this._scrollLeft - walk;
        });
    };

    /* Public methods
    ******************** */
    initialize = () => {
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this._initDragScroll();
            });
        } else {
            this._initDragScroll();
        }
    };
}

export default new Testimonials();
